import { routeDetails } from '@/app/creators/constants';
import { CHANNELS } from '@/models/dashboards/channels.enum';

const App = () => import('@/app/creators/App.vue');
const Overview = () => import('@/app/creators/pages/Overview.vue');
const YourCreators = () => import('@/app/creators/pages/YourCreators.vue');
const TikTokDiscovery = () => import('@/app/creators/pages/TikTokDiscovery.vue');
const InstagramDiscovery = () => import('@/app/creators/pages/InstagramDiscovery.vue');
const Payees = () => import('@/app/creators/pages/Payees.vue');
const PaymentHistory = () => import('@/app/creators/pages/PaymentHistory.vue');
const InfluentialFans = () => import('@/app/creators/pages/InfluentialFans.vue');

export default {
  path: routeDetails.CREATORS.name,
  component: App,
  children: [
    {
      name: routeDetails.CREATORS.name,
      path: routeDetails.CREATORS.path,
      redirect: { name: routeDetails.OVERVIEW.name },
    },
    {
      name: routeDetails.OVERVIEW.name,
      path: routeDetails.OVERVIEW.path,
      component: Overview,
      meta: {
        analytics: `${routeDetails.CREATORS.title} - ${routeDetails.OVERVIEW.title}`,
      },
    },
    {
      name: routeDetails.YOUR_CREATORS.name,
      path: routeDetails.YOUR_CREATORS.path,
      component: YourCreators,
      meta: {
        analytics: `${routeDetails.CREATORS.title} - ${routeDetails.YOUR_CREATORS.title}`,
      },
    },
    {
      name: routeDetails.CREATOR_DISCOVERY.name,
      path: routeDetails.CREATOR_DISCOVERY.path,
      redirect: { name: routeDetails.TIKTOK_DISCOVERY.name },
    },
    {
      name: routeDetails.TIKTOK_DISCOVERY.name,
      path: routeDetails.TIKTOK_DISCOVERY.path,
      component: TikTokDiscovery,
      meta: {
        analytics: `${routeDetails.CREATORS.title} - ${routeDetails.TIKTOK_DISCOVERY.title} Discovery`,
      },
    },
    {
      name: routeDetails.INSTAGRAM_DISCOVERY.name,
      path: routeDetails.INSTAGRAM_DISCOVERY.path,
      component: InstagramDiscovery,
      meta: {
        analytics: `${routeDetails.CREATORS.title} - ${routeDetails.INSTAGRAM_DISCOVERY.title} Discovery`,
      },
    },
    {
      name: routeDetails.CREATOR_PAYMENT.name,
      path: routeDetails.CREATOR_PAYMENT.path,
      redirect: { name: routeDetails.PAYEES.name },
    },
    {
      name: routeDetails.PAYEES.name,
      path: routeDetails.PAYEES.path,
      component: Payees,
      meta: {
        analytics: `${routeDetails.CREATORS.title} - ${routeDetails.PAYEES.title}`,
      },
    },
    {
      name: routeDetails.PAYMENT_HISTORY.name,
      path: routeDetails.PAYMENT_HISTORY.path,
      component: PaymentHistory,
      meta: {
        analytics: `${routeDetails.CREATORS.title} - ${routeDetails.PAYMENT_HISTORY.title}`,
      },
    },
    {
      name: routeDetails.INFLUENTIAL_FANS_TT.name,
      path: routeDetails.INFLUENTIAL_FANS_TT.path,
      component: InfluentialFans,
      props: {
        channel: CHANNELS.TIKTOK.value,
      },
      meta: {
        analytics: `${routeDetails.CREATORS.title} - ${routeDetails.INFLUENTIAL_FANS_TT.title} Influential Fans`,
      },
    },
    {
      name: routeDetails.INFLUENTIAL_FANS_IG.name,
      path: routeDetails.INFLUENTIAL_FANS_IG.path,
      component: InfluentialFans,
      props: {
        channel: CHANNELS.INSTAGRAM.value,
      },
      meta: {
        analytics: `${routeDetails.CREATORS.title} - ${routeDetails.INFLUENTIAL_FANS_IG.title} Influential Fans`,
      },
    },
  ],
  meta: {
    requiresAuth: true,
    internal: true,
  },
};
